export const heroBenefits = [
  { value: '25', label: 'Ready-to-Run Games' },
  { value: '10', label: 'Visual Stations' },
  { value: '8', label: 'Complete Lesson Plans' },
  { value: '', label: 'Print & Play Resources' },
]

export const proofCaptions = [
  { title: 'Visual setups', text: 'Know exactly where students, cones and equipment go.' },
  { title: 'Step-by-step movement', text: 'See how every activity runs before class begins.' },
  { title: 'Coaching cues', text: 'Short instructions that help you teach without stopping the whole class.' },
  { title: 'Adaptations', text: 'Make activities easier or harder depending on your students.' },
]

export const problemWants = [
  'You want Halloween week to feel different.',
  'Your students are excited.',
  'You want them moving.',
  'You want the lesson to feel fun.',
]

export const problemPains = [
  'Searching online for random Halloween PE games.',
  'Saving activities that do not work together.',
  'Trying to understand unclear setups.',
  'Adapting games for your space or class size.',
  'Figuring out what to do when you have little equipment.',
  'Building an entire lesson around one decent activity.',
]

export const solutionSteps = [
  { step: 'Step 1', title: 'Choose', text: 'Pick a game, station circuit or complete lesson.' },
  { step: 'Step 2', title: 'Set up', text: 'Use the visual layout to organize your space and equipment.' },
  { step: 'Step 3', title: 'Teach', text: 'Follow the short rules, movement steps and coaching cues.' },
]

export const gameSkills = [
  'Agility',
  'Reaction',
  'Passing',
  'Throwing',
  'Teamwork',
  'Spatial awareness',
  'Coordination',
  'Movement skills',
]

export const gameExamples = [
  'Zombie Escape',
  'Ghostbusters',
  'Pumpkin Rescue',
  'Witch’s Delivery',
  'Monster Freeze Tag',
  'Spider Web Challenge',
  'Skeleton Relay',
  'Zombie Infection',
  'Monster Maze',
  'Halloween Capture',
  'Ghost Ball',
  'Graveyard Dash',
]

export const stations = [
  'Pumpkin Agility',
  'Zombie Crawl',
  'Witch Balance',
  'Ghost Throw',
  'Spider Jump',
  'Monster Sprint',
  'Skeleton Coordination',
  'Haunted Dribble',
  'Pumpkin Target',
  'Graveyard Shuttle',
]

export const lessons = [
  '30-Minute Halloween PE Class',
  '45-Minute Halloween PE Class',
  '60-Minute Halloween PE Class',
  'Small-Space Halloween Lesson',
  'Outdoor Halloween Lesson',
  'No-Equipment Halloween Lesson',
  'Large-Group Halloween Plan',
  'Last-Minute Halloween Lesson',
]

export const ageGroups = ['K–2', 'Grades 3–5', 'Middle School']

export const adjustments = ['Space', 'Speed', 'Rules', 'Defenders', 'Equipment', 'Decision-making', 'Difficulty']

export const quickFixes = [
  'Students are waiting too long?',
  'The game is too easy?',
  'The game is too difficult?',
  'Students are confused?',
  'You have too many students?',
  'Your gym is too small?',
]

export const printPackItems = [
  {
    title: 'Teacher Quick Guide',
    text: 'A fast reference for choosing activities, organizing the space, explaining games and keeping students moving.',
  },
  {
    title: 'Halloween PE Warm-Ups',
    text: '5 short ready-to-use warm-ups that can be added to almost any Halloween lesson.',
  },
  {
    title: 'Halloween Corner Signs',
    text: 'Pumpkin, Ghost, Zombie and Witch signs ready to print and place around the gym.',
  },
  {
    title: 'Monster Movement Cards',
    text: 'Printable movement prompts students can draw, follow and use in stations or quick activities.',
  },
  {
    title: 'Skeleton Builder',
    text: 'A printable cut-and-build skeleton resource designed to work with the Skeleton Relay and Skeleton Builder activities.',
  },
]

export const situations = [
  { question: 'No special equipment?', answer: 'Use the no-equipment lesson.' },
  { question: 'Small gym?', answer: 'Use the small-space adaptations.' },
  { question: '30–40 students?', answer: 'Use multiple zones and timed rotations.' },
  { question: 'Only 30 minutes?', answer: 'Open the ready-made 30-minute lesson.' },
  { question: 'Class starts soon?', answer: 'Use the last-minute lesson structure.' },
  { question: 'Mixed ability group?', answer: 'Use the easier and harder variations.' },
]

export const withoutItems = [
  'Searching online the night before',
  'Random activities that do not connect',
  'Long explanations',
  'Unclear setup',
  'Too much waiting',
  'No backup plan',
  'Starting from zero every class',
]

export const withItems = [
  'Choose a ready activity',
  'Follow the visual setup',
  'Use short coaching cues',
  'Adapt the difficulty',
  'Keep students moving',
  'Use a complete lesson when needed',
]

export const audience = [
  'Elementary PE Teachers',
  'Middle School PE Teachers',
  'Primary School PE Teachers',
  'PE Specialists',
  'Substitute PE Teachers',
  'After-School Programs',
  'School Activity Leaders',
]

export const notDesignedAs = [
  'A video course.',
  'A physical book.',
  'A complicated curriculum that takes weeks to learn.',
]

export const offerIncludes = [
  '60-Page Visual Halloween PE System',
  '25 Ready-to-Run Games',
  '10 Visual Stations',
  '8 Complete Lesson Options',
  'Age Adaptations',
  'Small-Space Solutions',
  'Large-Group Solutions',
  'No-Equipment Options',
  'Quick-Fix Guides',
  'Halloween Print & Play Resource Pack',
]

export const readyList = [
  'The games are ready.',
  'The stations are ready.',
  'The lesson options are ready.',
  'The printable resources are ready.',
]

export const finalSummary = [
  '25 ready-to-run games',
  '10 visual stations',
  '8 complete lesson options',
  'Printable resources',
  'One organized system',
]
